import { gql } from 'graphql-request'

export const FragmentLinkReferences = gql`
  fragment FragmentLinkReferences on RecordInterface {
  __typename
  ... on ArticleModelRecord {
    id
    slug
    categories {
      id
      slug
    }
  }
  ... on CustomerModelRecord {
    id
    slug
  }
  ... on PageModelRecord {
    id
    slug
  }
  ... on IntegrationModelRecord {
    id
    slug
  }
  ... on IntegrationCategoryModelRecord {
    id
    slug
  }
  ... on NavigationItemModelRecord {
    id
    externalUrl
    relativePath
    __typename
  }
}
`
/* 
    ... on Asset {
      sys {
        id
      }
      __typename
      url
    }
*/